/* ─────────────────────────────────────────
   RiggloSIM Customer Dashboard JS
   File: assets/rigglosim-dashboard.js
   ───────────────────────────────────────── */

   // Remove Shopify authentication query parameters
if (window.location.search) {
  window.history.replaceState(
    {},
    document.title,
    window.location.pathname
  );
}

(function () {

  async function apiFetch(url, options = {}) {

  const response = await fetch(url, {
    credentials: "same-origin",
    headers: {
      "Accept": "application/json",
      ...(options.headers || {})
    },
    ...options
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  return await response.json();
}

  /* ── Only run dashboard logic on the dashboard page ── */
  var isDashboard = document.getElementById('rg-overview') !== null;

  var FLAGS = {
    'bangladesh':'🇧🇩','thailand':'🇹🇭','malaysia':'🇲🇾',
    'saudi arabia':'🇸🇦','turkey':'🇹🇷','india':'🇮🇳',
    'uae':'🇦🇪','united arab emirates':'🇦🇪','qatar':'🇶🇦',
    'kuwait':'🇰🇼','bahrain':'🇧🇭','oman':'🇴🇲',
    'pakistan':'🇵🇰','indonesia':'🇮🇩','philippines':'🇵🇭',
    'vietnam':'🇻🇳','singapore':'🇸🇬','japan':'🇯🇵',
    'south korea':'🇰🇷','china':'🇨🇳','nepal':'🇳🇵',
    'sri lanka':'🇱🇰','uk':'🇬🇧','united kingdom':'🇬🇧',
    'usa':'🇺🇸','united states':'🇺🇸','canada':'🇨🇦',
    'australia':'🇦🇺','europe':'🇪🇺','france':'🇫🇷',
    'germany':'🇩🇪','italy':'🇮🇹','spain':'🇪🇸',
    'egypt':'🇪🇬','nigeria':'🇳🇬','kenya':'🇰🇪',
    'global':'🌍','worldwide':'🌍'
  };

  function getFlag(title) {
    if (!title) return '🌐';
    var key = title.toLowerCase().trim();
    for (var k in FLAGS) { if (key.indexOf(k) !== -1) return FLAGS[k]; }
    return '🌐';
  }

  function escHtml(str) {
    return (str||'').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function parsePlan(v) {
    if (!v || v === 'Default Title') return null;
    return v;
  }

  function uniqueByProduct(orders) {
    var seen = {}, result = [];
    orders.forEach(function(o) {
      var k = (o.productHandle || o.productTitle || '').toLowerCase();
      if (!seen[k]) { seen[k] = true; result.push(o); }
    });
    return result;
  }

  function safeSet(id, val) {
    var el = document.getElementById(id);
    if (el) el.textContent = val;
  }

  function safeHtml(id, val) {
    var el = document.getElementById(id);
    if (el) el.innerHTML = val;
  }

  function renderDashboard() {
    if (!isDashboard) return; 

    var orders  = window.RG_ORDERS || [];
    


    /* Flag emojis on static order rows */
    document.querySelectorAll('.rg-ord-flag[data-country]').forEach(function(el) {
      el.textContent = getFlag(el.getAttribute('data-country'));
    });

    /* Attach modal triggers — use event delegation so dynamic buttons work too */
    attachModalTriggers();
  
if(window.RG_CUSTOMER && window.RG_CUSTOMER.email){

    loadDashboardStats();

    loadAllEsims();

}
  }

  /* ══ EVENT DELEGATION for modal triggers ══
     Attaches ONE listener to the document so dynamically rendered
     buttons (order rows, esim cards) all work without re-attaching  */
  function attachModalTriggers() {
    if (!isDashboard) return;
    /* Remove any previous listener to avoid duplicates */
    document.removeEventListener('click', handleModalClick);
    document.addEventListener('click', handleModalClick);
  }

  function handleModalClick(e) {
    var el = e.target.closest('.rg-open-modal');
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    openModal(
      el.getAttribute('data-title')  || '',
      el.getAttribute('data-plan')   || '',
      el.getAttribute('data-handle') || ''
    );
  }

  /* ══ MODAL ══ */
  var currentHandle   = '';
  var selectedVariant = null;

  function openModal(title, lastPlan, handle) {
    if (!isDashboard) return;
    currentHandle   = handle;
    selectedVariant = null;

    var flagEl    = document.getElementById('rgModalFlag');
    var countryEl = document.getElementById('rgModalCountry');
    var prevEl    = document.getElementById('rgModalPrev');
    var titleEl   = document.getElementById('rgModalTitle');
    var optsEl    = document.getElementById('rgPlanOptions');
    var totalEl   = document.getElementById('rgModalTotal');
    var checkBtn  = document.getElementById('rgCheckoutBtn');
    var overlay   = document.getElementById('rgModalOverlay');

    if (!overlay) return;

    if (flagEl)    flagEl.textContent    = getFlag(title);
    if (countryEl) countryEl.textContent = title;
    if (prevEl)    prevEl.textContent    = lastPlan ? 'Last plan: ' + lastPlan : 'Choose a plan below';
    if (titleEl)   titleEl.textContent   = 'Top up / buy again';
    if (optsEl)    optsEl.innerHTML      = '<p style="font-size:13px;color:#aaa;grid-column:1/-1;padding:8px 0">Loading plans…</p>';
    if (totalEl)   totalEl.textContent   = '—';
    if (checkBtn) {
      checkBtn.removeAttribute('href');
      checkBtn.style.opacity       = '0.5';
      checkBtn.style.pointerEvents = 'none';
    }

    overlay.classList.remove('rg-hidden');
    document.body.style.overflow = 'hidden';

    if (!handle) {
      if (optsEl) optsEl.innerHTML = '<p style="font-size:13px;color:#aaa;grid-column:1/-1">'
        + 'No product found. <a href="/collections/all" style="color:#0EA5E9">Browse all plans →</a></p>';
      return;
    }

apiFetch('/products/' + handle + '.js')
.then(function(product) {

    var variants = product.variants || [];

    if (!variants.length) {
        throw new Error('no variants');
    }

    selectedVariant = variants[0];

    renderPlanOptions(variants);

    updateModalTotal(selectedVariant);

    enableCheckout(selectedVariant);

})
      .catch(function() {
        if (optsEl) optsEl.innerHTML = '<p style="font-size:13px;color:#aaa;grid-column:1/-1">'
          + 'Could not load plans. <a href="/products/' + handle + '" style="color:#0EA5E9">View product →</a></p>';
        if (checkBtn) {
          checkBtn.href = '/products/' + handle;
          checkBtn.style.opacity       = '';
          checkBtn.style.pointerEvents = '';
        }
      });
  }

  function renderPlanOptions(variants) {
    var container = document.getElementById('rgPlanOptions');
    if (!container) return;
    container.innerHTML = '';
    variants.forEach(function(v, i) {
      var div      = document.createElement('div');
      div.className = 'rg-plan-opt' + (i === 0 ? ' rg-sel' : '');
      var price    = (v.price / 100).toFixed(2);
      var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
      div.innerHTML = '<div class="rg-plan-gb">' + escHtml(v.title) + '</div>'
        + '<div class="rg-plan-price">' + currency + ' ' + price + '</div>';
      div.addEventListener('click', function() {
        document.querySelectorAll('.rg-plan-opt').forEach(function(el) { el.classList.remove('rg-sel'); });
        div.classList.add('rg-sel');
        selectedVariant = v;
        updateModalTotal(v);
        enableCheckout(v);
      });
      container.appendChild(div);
    });
  }

  function updateModalTotal(variant) {
    if (!variant) return;
    var price    = (variant.price / 100).toFixed(2);
    var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
    safeSet('rgModalTotal', currency + ' ' + price);
  }

  function enableCheckout(variant) {
    if (!variant) return;
    var btn = document.getElementById('rgCheckoutBtn');
    if (!btn) return;
    btn.style.opacity       = '';
    btn.style.pointerEvents = '';
  }

  /* Checkout — POST to cart/add then go to checkout */
  document.addEventListener('DOMContentLoaded', function() {
    var btn = document.getElementById('rgCheckoutBtn');
    if (!btn) return;
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      if (!selectedVariant) return;
      btn.textContent      = 'Adding to cart…';
      btn.style.opacity    = '0.7';
apiFetch('/cart/add.js', {
    method:'POST',
    headers:{
        'Content-Type':'application/json'
    },
    body:JSON.stringify({
        id:selectedVariant.id,
        quantity:1
    })
})
.then(function(){

    window.location.href='/checkout';

})
.catch(function(){

    window.location.href='/products/'+currentHandle;

});
  });
});
  /* Close modal */
  window.rgCloseModal = function(e) {
    if (e && e.target !== document.getElementById('rgModalOverlay')) return;
    var overlay = document.getElementById('rgModalOverlay');
    if (overlay) overlay.classList.add('rg-hidden');
    document.body.style.overflow = '';
  };

  /* Tab switching */
  window.rgTab = function(name, el) {
    if (!isDashboard) return;
    ['overview','esims','orders','profile'].forEach(function(t) {
      var tab = document.getElementById('rg-' + t);
      if (tab) tab.classList.add('rg-hidden');
    });
    document.querySelectorAll('.rg-tab').forEach(function(t) { t.classList.remove('active'); });
    var active = document.getElementById('rg-' + name);
    if (active) active.classList.remove('rg-hidden');
    el.classList.add('active');

  if(name === 'esims'){

   if(
window.RG_CUSTOMER &&
window.RG_CUSTOMER.email
)
{

        loadAllEsims();

        if(window.RG_ORDERS && window.RG_ORDERS.length){

            setTimeout(function(){

                loadEsim(window.RG_ORDERS[0].orderNumber);

            },100);

        }

    }

}

  };

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var overlay = document.getElementById('rgModalOverlay');
      if (overlay) overlay.classList.add('rg-hidden');
      document.body.style.overflow = '';
    }
  });

  window.addEventListener("load", () => {

  const wait = setInterval(() => {

    const overview = document.getElementById("rg-overview");

    if (
overview &&
window.RG_CUSTOMER &&
window.RG_CUSTOMER.email
) {

      clearInterval(wait);
      renderDashboard();

    }

  }, 500);

});

     async function loadDashboardStats(){

  try{

    const response = await fetch(
`${window.RG_CONFIG.apiBase}/api/dashboard/${encodeURIComponent(window.RG_CUSTOMER.email)}`
);

const data = await response.json();

    if(!data.success){
      return;
    }

    const activeCount =
document.getElementById('rgActiveCount');

if(activeCount){
    activeCount.textContent =
    data.activeEsims;
}

const activeNames =
document.getElementById('rgActiveNames');

if(activeNames){
    activeNames.textContent =
    data.activeEsims===1
    ? '1 Active Plan'
    : `${data.activeEsims} Active Plans`;
}

 renderOverviewCards(data);
  renderBuyAgain(data);

const countryCount =
document.getElementById('rgCountryCount');

if(countryCount){
    countryCount.textContent =
    data.totalEsims;
}

  }catch(err){

    console.error(err);

  }

}
function renderOverviewCards(data){

const container =
document.getElementById('rgActivePlans');

if(!container) return;

container.innerHTML='';

data.esims.forEach(esim=>{
const hasExpiry = !!esim.expiry_date;

const daysLeft = hasExpiry
  ? Math.ceil(
      (
        new Date(esim.expiry_date) -
        new Date()
      ) / 86400000
    )
  : null;

const isExpired = hasExpiry && daysLeft <= 0;
const isNotActivated =
  !hasExpiry &&
  esim.esim_status === 'GOT_RESOURCE';

const badgeText =
  isNotActivated
    ? 'NOT ACTIVATED'
    : isExpired
      ? 'EXPIRED'
      : 'ACTIVE';

const badgeColor =
  isNotActivated
    ? '#f59e0b'
    : isExpired
      ? '#dc2626'
      : '#16a34a';



container.innerHTML += `

<div class="rg-esim-card rg-live-blue">

<div class="rg-esim-country">
${esim.product_name}
</div>

<div class="rg-esim-plan">

${esim.total_volume}

<br>

${esim.used_volume} used

<div
style="
height:8px;
background:#ECECEC;
border-radius:20px;
margin-top:10px;
overflow:hidden;
">

<div
style="
height:100%;
width:${Math.min(
(parseFloat(esim.used_volume)||0)/
(parseFloat(esim.total_volume)||1)
*100,
100
)}%;
background:#0EA5E9;
border-radius:20px;
">
</div>

</div>

<div
style="
margin-top:8px;
font-size:13px;
color:#666;
">
Remaining:
${(
(parseFloat(esim.total_volume)||0)
-
(parseFloat(esim.used_volume)||0)
).toFixed(2)} GB
</div>

</div> <!-- rg-esim-plan ends here -->

<div style="margin-top:12px;">

<span
class="rg-badge"
style="background:${badgeColor};color:white;"
>
${badgeText}
</span>

</div>

<div
style="
margin-top:10px;
font-size:13px;
font-weight:600;
color:${
  isNotActivated
    ? '#b45309'
    : isExpired
      ? '#dc2626'
      : '#111827'
};
">
${
  isNotActivated
    ? 'Not activated yet'
    : isExpired
      ? 'Expired'
      : `Expires in ${daysLeft} day${daysLeft === 1 ? '' : 's'}`
}
</div>
<button
class="rg-btn rg-btn-blue"
style="margin-top:15px;width:100%;"
onclick="document.querySelector('.rg-tab[onclick*=esims]').click();
loadEsim('${esim.order_number}')"
>

Manage eSIM

</button>

</div>

`;

});

}
function renderBuyAgain(data){

const container =
document.getElementById("rgPastCountries");
if(!container) return;

container.innerHTML="";

data.buyAgain.forEach(esim=>{

  const handle = (esim.product_name || "")
  .split(" - ")[0]
  .trim()
  .toLowerCase()
  .replace(/\s+/g, "-");

container.innerHTML += `

<div class="rg-country-card">

<div class="rg-country-name">
${esim.product_name}
</div>

<div class="rg-country-plan">
${esim.total_volume}
</div>

<a
href="/products/${handle}"
class="rg-btn rg-btn-blue"
>
Buy Again
</a>
</div>

`;

});

}

async function loadAllEsims(){

  try{

    const response = await fetch(
`${window.RG_CONFIG.apiBase}/api/esims/${encodeURIComponent(window.RG_CUSTOMER.email)}`
);
const result = await response.json();
const container =
document.getElementById('rgEsimList');

if(!container){
    return;
}

container.innerHTML='';

const countries = new Set();

result.data.forEach(esim => {

  const country =
  (esim.product_name || '')
  .split('-')[0]
  .trim();

  if(country){
    countries.add(country);
  }

});
    result.data.forEach(esim => {

const hasExpiry = !!esim.expiry_date;

const daysLeft = hasExpiry
  ? Math.ceil(
      (
        new Date(esim.expiry_date) -
        new Date()
      ) / 86400000
    )
  : null;

const packageExpired = hasExpiry && daysLeft <= 0;

const packageNotActivated =
  !hasExpiry &&
  esim.esim_status === 'GOT_RESOURCE';


      container.innerHTML += `
        <div
          onclick="loadEsim('${esim.order_number}')"
          style="
            background:white;
            border:1px solid #e5e7eb;
            border-radius:14px;
            padding:15px;
            margin-bottom:12px;
            cursor:pointer;
          "
        >

          <div style="
            display:flex;
            justify-content:space-between;
            align-items:center;
          ">

            <strong>
              ${esim.product_name || 'eSIM'}
            </strong>

            <span style="
              padding:4px 10px;
              border-radius:20px;
              font-size:12px;
              color:white;
            background:
${
  packageNotActivated
    ? '#f59e0b'
    : packageExpired
      ? '#dc2626'
      : '#16a34a'
};
            ">
           ${
  packageNotActivated
    ? 'NOT ACTIVATED'
    : packageExpired
      ? 'EXPIRED'
      : 'ACTIVE'
}
            </span>

          </div>

          <div style="
            margin-top:8px;
            color:#6b7280;
            font-size:13px;
          ">
            Order #${esim.order_number}
          </div>

        </div>
      `;

    });
    const countryCount =
document.getElementById('rgCountryCount');

if(countryCount){

  countryCount.textContent =
  countries.size;

}

  }catch(err){

    console.error(err);

  }

}
window.loadEsim = async function(orderNumber){
  console.log("Loading eSIM:", orderNumber);

  try{

    const data = await apiFetch(
  `${window.RG_CONFIG.apiBase}/api/esim/${orderNumber}`
);

    
    console.log("API Response:", data);

    const esimContainer = document.getElementById('rgEsimDetails');
      console.log("Container:", esimContainer);

          console.log("data.success =", data.success);
    console.log("QR =", data.data.qr_code_url);
    console.log("About to render...");

    const total = parseFloat(data.data.total_volume) || 1;

    const used = parseFloat(data.data.used_volume) || 0;

const usagePercent =
Math.min(
Math.round((used/total)*100),
100
);

const hasExpiry = !!data.data.expiry_date;

const daysLeft = hasExpiry
  ? Math.ceil(
      (
        new Date(data.data.expiry_date) -
        new Date()
      ) / (1000 * 60 * 60 * 24)
    )
  : null;

const isNotActivated =
  !hasExpiry &&
  data.data.esim_status === 'GOT_RESOURCE';

const isExpired =
  hasExpiry &&
  daysLeft <= 0;

if (esimContainer && data.success) {

  esimContainer.innerHTML = `
    <div style="
  background:#fff;
  border-radius:20px;
  padding:20px;
  box-shadow:
  0 8px 20px rgba(0,0,0,.08);
">

<h3 style="
margin-bottom:12px;
font-size:18px;
font-weight:700;
color:#111827;
">
${data.data.product_name || 'eSIM'}
</h3>

    <img
  src="${data.data.qr_code_url}"
  width="220"
  style="
    display:block;
    margin:auto;
    border:1px solid #e5e7eb;
    border-radius:12px;
    padding:10px;
    background:white;
    margin-bottom:15px;
  "
>

      <p>
        <strong>Order Number:</strong>
        #${data.data.order_number}
      </p>
<p>
<strong>eSIM Profile:</strong>

<span style="
  display:inline-block;
  padding:5px 9px;
  border-radius:999px;
  background:${isNotActivated ? '#f59e0b' : '#16a34a'};
  color:white;
  font-size:11px;
  font-weight:600;
  white-space:nowrap;
">
  ${isNotActivated ? 'READY' : 'INSTALLED'}
</span>

</p>
<p>
<strong>Usage:</strong>
${data.data.used_volume}
/
${data.data.total_volume}
</p>

<p>
<strong>Remaining:</strong>
${(total-used).toFixed(2)} GB
</p>

<div style="
width:100%;
height:10px;
background:#e5e7eb;
border-radius:999px;
overflow:hidden;
margin-bottom:15px;
">

<div style="
width:${usagePercent}%;
height:100%;
background:#2563eb;
"></div>

</div>

${
usagePercent >= 80
?
`
<div style="
margin-top:10px;
background:#fef3c7;
padding:10px;
border-radius:10px;
color:#92400e;
font-weight:600;
">
⚠ Low data remaining
</div>
`
:
''
}

<p>
<strong>Package Validity:</strong>

${
  isNotActivated
    ? `
      <span style="font-weight:700;color:#f59e0b;">
        Not Activated
      </span>

      <span style="color:#111827;">
        • Ready to activate
      </span>
    `
    : isExpired
      ? `
        <span style="font-weight:700;color:#dc2626;">
          Expired
        </span>
        `
      : `
        <span style="font-weight:700;color:#16a34a;">
          Valid
        </span>

        <span style="color:#111827;">
          • ${daysLeft} day${daysLeft === 1 ? '' : 's'} remaining
        </span>
        `
}

</p>
      <p>
        <strong>Activation Code:</strong>
      </p>

      <textarea
        readonly
        style="
          width:100%;
          height:90px;
          padding:10px;
        "
      >${data.data.activation_code}</textarea>

<button
onclick="
navigator.clipboard.writeText('${data.data.activation_code}');
this.innerText='Copied ✓';
setTimeout(()=>{
this.innerText='Copy Activation Code';
},2000);
"
style="
width:100%;
margin-top:10px;
padding:12px;
background:#2563eb;
color:white;
border:none;
border-radius:10px;
font-weight:600;
cursor:pointer;
"
>
Copy Activation Code
</button>
    <a
  href="${window.RG_CONFIG.apiBase}/download-qr/${data.data.order_number}"
  style="
    display:block;
    text-align:center;
    background:#111827;
    color:white;
    padding:12px;
    border-radius:10px;
    text-decoration:none;
    margin-top:10px;
  "
>
  Download QR
</a>


</div>
`;

 console.log("Rendered successfully");
 setTimeout(() => {
    console.log("After 2 seconds:", document.getElementById("rgEsimDetails").innerHTML);
}, 2000);
}

  }catch(err){
    console.error(err);
  }

}


})();